import { useLocation, useSearchParams } from "react-router-dom";

export function directorReturn(location, family, matchId) {
  const expected = `/matches/manage/${family}/${encodeURIComponent(matchId)}`;
  return location.state?.directorPath === expected ? expected : null;
}

// Keep return destinations within the two competitor match lists.
export function discoveryReturn(location, fallback = "/matches") {
  const path = location.state?.discoveryPath;
  return typeof path === "string" && /^\/matches(?:\/my)?(?:\?[^#\r\n]*)?$/.test(path) && !/[\r\n]/.test(path) ? path : fallback;
}

export function discoveryReturnLabel(location, fallback = "Find matches") {
  return /^\/matches\/my(?:\?|$)/.test(discoveryReturn(location)) ? "My matches" : fallback;
}

export function resultsReturn(location, matchId) {
  const fallback = matchId ? `/matches/arc/${encodeURIComponent(matchId)}` : "/matches";
  // The URL copy survives sign-in, which cannot retain React Router state.
  const path = location.state?.resultsPath || new URLSearchParams(location.search || "").get("results");
  return typeof path === "string" && !/[\r\n#]/.test(path)
    && (path === fallback || path.startsWith(`${fallback}?`)) ? path : fallback;
}

// URL filters survive score-detail navigation, browser Back and a reload.
export function useResultFilters() {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  function update(patch) {
    const next = new URLSearchParams(params);
    Object.entries(patch).forEach(([key, value]) => {
      if (!value || (["division", "squad"].includes(key) && value === "all") || (key === "section" && value === "overall")) next.delete(key);
      else next.set(key, value);
    });
    setParams(next, { replace: true, state: location.state });
  }
  return { params, update, scoreState: { ...location.state, resultsPath: location.pathname + location.search } };
}

export function displayReturn(location, fallback) {
  const path = location.state?.displayReturn;
  return typeof path === "string" && /^\/matches\/manage\/displays(?:\?[^#\r\n]*)?$/.test(path) && !/[\r\n]/.test(path) ? path : fallback;
}
